import { Component, ContentChild, OnInit, TemplateRef } from '@angular/core';
import { ScreenBreakpointObserverService } from 'src/app/shared/foundation/utils/breakpoint-observer.service';

@Component({
  selector: 'app-content-layout-v2',
  templateUrl: './content-layout-v2.component.html',
  styleUrls: ['./content-layout-v2.component.scss'],
})
export class ContentLayoutV2Component implements OnInit {
  isMobileLayout = false;
  isExpanded = false;

  @ContentChild('start', { static: false }) public start: TemplateRef<any>;
  @ContentChild('center', { static: false }) public center: TemplateRef<any>;
  @ContentChild('end', { static: false }) public end: TemplateRef<any>;

  constructor(private bpObserverService: ScreenBreakpointObserverService) {}

  ngOnInit(): void {
    this.bpObserverService.screenSizeObserver.subscribe({
      next: (res) => {
        if (res.length <= 2) {
          this.isMobileLayout = true;
        } else {
          this.isMobileLayout = false;
        }
      },
    });
  }

  toggleListViewExpansion(): void {
    this.isExpanded = !this.isExpanded;
  }
}
